"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _Radio = _interopRequireDefault(require("./Radio.styles"));
var _excluded = ["label", "data-id"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Radio = function Radio(_ref) {
  var label = _ref.label,
    dataIdProp = _ref['data-id'],
    props = _objectWithoutProperties(_ref, _excluded);
  var dataId = dataIdProp;
  if (!dataId && typeof label === 'string') {
    dataId = label.toLowerCase().replace(/ /g, '-');
  }

  // HOOKS
  var classes = (0, _Radio.default)();

  // MISC
  var _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value;
  return /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    classes: {
      label: classes.label
    },
    value: value,
    control: /*#__PURE__*/_react.default.createElement(_core.Radio, _extends({
      className: classes.root,
      disableRipple: true,
      color: "default",
      checkedIcon: /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(classes.icon, classes.checkedIcon)
      }),
      icon: /*#__PURE__*/_react.default.createElement("span", {
        className: classes.icon
      }),
      "data-id": dataId && "".concat(dataId, "-radio")
    }, props)),
    label: label,
    "data-id": dataId
  });
};
var _default = Radio;
exports.default = _default;